<template>
	<div class="cresentation FlexBox FlexAliCenter">
		<!-- 数据表现  -->
		<div class="senta_item FlexBox FlexDirColumn" v-for="(item, index) in list">
			<div class="tit"> 
				{{item.title}}
			</div>
			<div class="num">
				{{item.num || 0}}
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: ()=>{
					return [];
				},
			},
		},
		data() {
			return {
			
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../css/report.scss";
	.cresentation{
		width: 100%;
		.senta_item:last-of-type{
			margin-right: 0;
		}
		.senta_item{
			margin-right: 19px;
			padding: 19px 26px;
			min-width: 148px;
			min-height: 103px;
			border-radius: 5px;
			background: rgba(249, 249, 249, 1);
			.tit{
				margin-bottom: 20px;
				font-size: 13px;
				color: rgba(96, 98, 102, 1);
				white-space: nowrap;
			}
			.num{
				font-size: 28px;
				color: rgba(43, 117, 235, 1);
				white-space: nowrap;
			}
		}
	}
	
</style>